<app-header *ngIf="!this.roleService.isQuickapi();"></app-header>
<router-outlet></router-outlet>

<app-to-top></app-to-top>
<app-footer></app-footer>
